import AuthenticationController from "./AuthenticationConteroller";
import LoginUiController from "./loginUI";

new LoginUiController({})